import React, { useEffect, useState } from "react"
import { connect } from 'react-redux'
import SysApi from '@api/sys'
import { message, Spin } from "antd"

const SingleLogin = ({ history, dispatch }) => {
  const [tipsTitle, setTipsTitle] = useState('身份验证中…')
  useEffect( () => {
    const href = window.location.href
    const idToken = href.split('idToken=')[1]
    if (!idToken) return message.error('请传递身份验证编号')
    SysApi.ssoLogin({idToken}).then(res => {
      if ( res.status !== '0' ) return message.error('身份验证失败'), setTipsTitle('身份验证失败')
      setTipsTitle('验证通过')
      let { data } = res
      sessionStorage.setItem('userInfo', JSON.stringify(data))
      sessionStorage.setItem('token', data.token)
      dispatch(success(data))
      history.replace('/stationManagement/factoryProgress')
    })
  },[])

  return (
    <div style={{'display': 'flex', 'width': '100vw', 'height': '100vh', 'justifyContent': 'center', 'alignItems': 'center'}}>
      <Spin tip={tipsTitle} size="large"></Spin>
    </div>
  )
}
const mapStateToProps = state => {
  return {
    ...state.Common
  }
};
export default connect(mapStateToProps)(SingleLogin)
